import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faQuestionCircle,
  faHourglassHalf,
} from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  "Pendiente": faHourglassHalf,
  "Liberada": faCheckCircle,
  "Subdivision y Abandono": faExclamationTriangle,
  "Abandono": faTimesCircle,
  "En espera de Complemento": faClock,
  default: faQuestionCircle,
};

const colorMap = {
  "Pendiente": "text-yellow-600",
  "Liberada": "text-green-600",
  "Subdivision y Abandono": "text-orange-500",
  "Abandono": "text-red-600",
  "En espera de Complemento": "text-blue-500",
  default: "text-gray-500",
};

const MiniDashboardGuiaStatus = ({ items, statusOptions }) => {
  // Reordenar manualmente 
  const orderedStatusValues = [
    "Abandono",
    "Liberada",
    "Subdivision y Abandono",
    "En espera de Complemento",
    "Pendiente",
  ];

  const orderedStatusOptions = orderedStatusValues.map((val) =>
    statusOptions.find((opt) => opt.value === val)
  ).filter(Boolean); 

  const counts = statusOptions.reduce((acc, status) => {
    acc[status.value] = 0;
    return acc;
  }, {});

  items.forEach((item) => {
    const estado = item.statusGuia;
    if (counts.hasOwnProperty(estado)) {
      counts[estado]++;
    }
  });

  return (
    <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
      <div className="text-xs text-gray-500 text-center mb-2 italic">
        * Statistics shown for current page only ({items.length} records)
      </div>
      <div className="grid grid-cols-5 divide-x divide-gray-200 text-center">
        {orderedStatusOptions.map((status) => {
          const icon = iconMap[status.value] || iconMap.default;
          const color = colorMap[status.value] || colorMap.default;
          return (
            <div key={status.value} className="flex flex-col items-center justify-center py-1">
              <FontAwesomeIcon icon={icon} className={`text-2xl mb-1 ${color}`} />
              <p className="text-sm text-gray-600 text-center">{status.label}</p>
              <p className="text-base font-semibold text-gray-800">
                {counts[status.value]}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MiniDashboardGuiaStatus;
